import React, { Component } from "react";

import "./Footer.scss"
import "../../static/fonts/heebo/stylesheet.css";

function Footer({section}) {
    return (
      <footer>
        <div id="footer">
          <div className={`padding ${section != "home" ? "black" : ""}`}>
          <ul>
            <a href="http://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank">תנאי שימוש</a>
            <li className="line"></li>
            <a href="http://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">מדיניות פרטיות</a>
            <li className="line"></li>
            <a href="https://www.yit.co.il/" target="_blank">עיצוב, איפיון ופיתוח <li className="yitlogo"></li></a>
            
            </ul>
          </div>
        </div>
      </footer>
    );
}

export default Footer;
